<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :ok-disabled="true"
    :okButtonProps="{ class:{'jee-hidden': true} }"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <emp-dev-app-apply-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit" :auditFlag="auditFlag"></emp-dev-app-apply-form>
  </j-modal>
</template>

<script>

  import EmpDevAppApplyForm from './EmpDevAppApplyForm'
  export default {
    name: 'EmpDevAppApplyModal',
    components: {
      EmpDevAppApplyForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        //this.auditFlag = false;
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      audit (record) {
        this.visible=true
        this.disableSubmit = true;
        this.auditFlag = true;
        this.$nextTick(()=>{
          this.$refs.realForm.audit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>